/**
 * @generated SignedSource<<061e228401dfd668dce6e024d0e99bc8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FileStatus = "ERROR" | "PENDING" | "PROCESSING" | "READY" | "WAIT_FOR_PROCESSING";
export type FileType = "DOC" | "DOCX" | "PDF" | "PPT" | "PPTX" | "XLS" | "XLSX";
import { FragmentRefs } from "relay-runtime";
export type SuggestionItem_File$data = {
  readonly id: string;
  readonly name: string | null;
  readonly pdfUrl: string;
  readonly status: FileStatus;
  readonly type: FileType | null;
  readonly " $fragmentSpreads": FragmentRefs<"FileThumbnail_file" | "SuggestionItemStatusDetail_File">;
  readonly " $fragmentType": "SuggestionItem_File";
};
export type SuggestionItem_File$key = {
  readonly " $data"?: SuggestionItem_File$data;
  readonly " $fragmentSpreads": FragmentRefs<"SuggestionItem_File">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SuggestionItem_File",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pdfUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SuggestionItemStatusDetail_File"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FileThumbnail_file"
    }
  ],
  "type": "File",
  "abstractKey": null
};

(node as any).hash = "4ec523de91990de75e57fc6491bf3701";

export default node;
